import { Serializer } from "jsonapi-serializer";
import { DateTime } from "luxon";
import { StudentProfileInfo } from "../../api/typings/Profiles";
import { IApiResourceResponse } from "../../@typings/client";

export async function getUpdateStudentData(
  profileInfo: StudentProfileInfo
): Promise<IApiResourceResponse<StudentProfileInfo>> {
  return new Serializer("users_profiles_students", {
    keyForAttribute: "snake_case",
    attributes: [
      "birthday",
      "school",
      "city",
      "social",
      "target_university",
      "target_score",
      "target_plan",
      "is_studying",
      "payment_history_start_date",
      "payment_reminder_dates",
      "payment_comment",
    ],
    transform(record: StudentProfileInfo) {
      if (record.payment_reminder_dates != null && !record.payment_reminder_dates.length) {
        record.payment_reminder_dates = null;
      } else {
        record.payment_reminder_dates = record.payment_reminder_dates?.map((date) =>
          DateTime.fromFormat(date, "dd.mm.yyyy").toFormat("yyyy-mm-dd")
        );
      }
      return record;
    },
  }).serialize(profileInfo);
}
